document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', function () {
    menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', menu.classList.contains('is-open') ? 'true' : 'false');
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1200) {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
});
